import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from 'swiper/bundle';
gsap.registerPlugin(ScrollTrigger);
class SectionReviews {
    constructor() {
        this.ScrollStart= "150 bottom";
        this.swiperReview = null;  // Define swiperReview at the class level
    }
    init(){
        let reviewSection=document.querySelector('.review')
        let reviewArt=reviewSection.querySelector('.review__art')
        let reviewTitle=reviewSection.querySelector('.section-title--outline')
        let reviewSubTitle=reviewSection.querySelector('.section-subtitle--white')
        let cardReviews=reviewSection.querySelectorAll('.card-review')

        window.addEventListener("resize", () => {
            this.reviews(window.innerWidth);
        });

        window.addEventListener("resize", () => {
            let windowWidth=window.innerWidth;
            if(windowWidth<=992){
                this.ScrollStart="start bottom";
            }else{
                this.ScrollStart="150 bottom";
            }
        });
        this.reviews(window.innerWidth);
    
        let reviewTl = gsap.timeline({
            scrollTrigger: {
                trigger: reviewSection,
                start: this.ScrollStart,
                end:"center center",
                // scrub: 1,
                //markers:true
            }
        });
        reviewTl.from(reviewArt, {duration: 0.5,xPercent: 100})
                .from(reviewTitle, {duration: 0.5,top: 300},"+=0.5")
                .from(reviewSubTitle, {duration: 0.5,top: 200})
                .fromTo(cardReviews, { y: "250%"}, { y: "0%", duration: 0.5, stagger: 0.2 });
    }
    
    reviews(viewportWidth){
        let containerReviews=document.querySelector(".review__inner");
        let containerReviewsWidth=containerReviews.offsetWidth
        let containerOffset=(viewportWidth - containerReviewsWidth) / 2;

        if (this.swiperReview) {
            this.swiperReview.destroy(true, true);
        }

        this.swiperReview = new Swiper('.swiper-review', {
            slidesPerView: 1.3,
            spaceBetween: 8,
            slidesOffsetBefore: containerOffset - 12,
            slidesOffsetAfter:containerOffset - 12,
            autoHeight:false,
            pagination: {
                el: ".review .swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".review .swiper-button-next",
                prevEl: ".review .swiper-button-prev",
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 24,
                    autoHeight:false,
                },
            },
        });
    }
}
export default SectionReviews